import prop from 'propget';

/**
 * Search target for nested properties and return it.
 *
 * @param {string} target global target
 * @param {string} properties Object properties.
 * @returns {Mixed|undefined} Result of lookup or undefined.
 */
export function get(target, properties) {
  const targets = {
    get global() { return typeof global !== 'undefined' && global; },
    get window() { return typeof window !== 'undefined' && window; }
  };

  return prop(targets[target], properties);
}

/**
 * Gets the function found in `global['@native/shell']` by the name provided.
 *
 * @param {String} functionName Name of the function to find
 * @returns {Function} Returns the function if found, undefined otherwise
 */
export function getFunctionFromGlobal(functionName) {
  return get('global', `@native/shell.${ functionName }`);
}
